import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import styles from './overrideSetupDialog.module.scss';

export default memo(function ConfirmationDialog(props) {
    const [t] = useTranslation('wizard');

    return (
        <Dialog open={props.open} onClose={props.closeDialog}>
            <DialogTitle>{t('wizard:proceed_to_quick_setup')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{t('wizard:proceed_to_quick_setup_detail')}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button autoFocus className={styles.actionButton} onClick={props.closeDialog}>
                    {t('common:confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}, (prevProps, nextProps) => prevProps.open === nextProps.open);
